'use client';

import { useEffect } from 'react';

export default function Metrics() {
  useEffect(() => {
    const acceptedProdEnv =
      process.env.NEXT_PUBLIC_ENVIRONMENT === 'Production-BR' ||
      process.env.NEXT_PUBLIC_ENVIRONMENT === 'Production-EU';

    if (acceptedProdEnv) {
      import('../utils').then((utils) => {
        if (utils.appendGoogleAnalyticsTrackingCode) {
          utils.appendGoogleAnalyticsTrackingCode();
        }
        if (utils.appendHotjarTrackingCode) {
          utils.appendHotjarTrackingCode();
        }
      }).catch(err => console.error(`Erro ao carregar analytics:`, err));
    }
  }, []);

  return null;
}